const $ = jQuery.noConflict()
var MAPS = require('./maps.google.js')
var LOCRATING = require('./locrating.js')

var self = module.exports = {
  init: function(trigger) {
    self.events.click(trigger)
    self.events.change(trigger)
  },

  events: {
    click: function(trigger) {
      $(document).on('click', trigger + ' a', function(e) {
        var el = $(e.target).closest(trigger)
        var panel = $(el).data('tab')

        self.service.toggle(el)
        self.service.show(panel)
        e.preventDefault()
      })
    },

    change: function(trigger) {
      $(document).on('change', trigger, function() {
        var value = $(this).val()
        var option = $(this).find('option[value="' + value + '"]')
        var panel = $(option).data('tab')

        self.service.show(panel)
      })
    },
  },

  service: {
    toggle: function(trigger) {
      $(trigger).addClass('active').siblings().removeClass('active')

      if ($(trigger).find('.street')) {
        $(document).trigger('streetShown')
      }
    },

    show: function(panel) {
      var slider = $(panel).find('[class*="slick"]')
      var map = $(panel).find('.map')
      var locrating = $(panel).find('.locrating')

      $(panel).addClass('active').siblings().removeClass('active')

      if (locrating.length) {
        LOCRATING.service.init(locrating)
      }
    }
  }
}
